import { Color } from '@diritto/common/style/color';
import { ZIndex } from 'constants/zIndex';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';

export const MenuContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 0;
  z-index: ${ZIndex.UserMenu};
  width: 260px;
  background: white;
  box-shadow:
    inset 0 0 1px rgba(0, 0, 0, 0.2),
    0 4px 56px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  overflow: hidden;
`;

export const Menu = styled.li`
  width: 100%;
  height: 48px;
  list-style-type: none;

  cursor: pointer;

  &:hover {
    background-color: ${Color.Primary100};
  }
`;

export const MenuItem = styled.p`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  ${Typography.XXSmall};
  gap: 4px;
`;

export const MenuWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  appearance: none;
  outline: none;
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const MenuBadge = styled.span`
  width: 56px;
  height: 20px;
  padding: 5px 6px;
  background: ${Color.Blue500};
  border-radius: 4px;
  font-size: 10px;
  line-height: 10px;
  ${FontWeight.Bold};
  color: ${Color.White};
`;
